import { MarketComparisonWritable } from 'api';
import { getUniqueComparisons } from 'pages/FundInvestments/utils/getUniqueComparisons';
import { parseFieldValue } from 'utilities';
import { GetComparisonsWithSingleWeightingParams } from './getComparisonsWithSingleWeighting.types';

const getComparisonsWithSingleWeighting = (params: GetComparisonsWithSingleWeightingParams) => {
  const { comparisons, marketDate } = params;

  const uniqueUpdatedComparisons = getUniqueComparisons({
    comparisons,
    date: marketDate,
    fallback: [],
  });

  // If there is only one unique comparison, set weighting to 100%
  if (uniqueUpdatedComparisons.length === 1) {
    return comparisons.map(
      comparison =>
        ({
          ...comparison,
          weight: parseFieldValue({ decimalPlaces: 4, type: 'DecimalField', value: 1 }),
        }) as MarketComparisonWritable
    );
  }

  return comparisons;
};

export default getComparisonsWithSingleWeighting;
